function Dealer() {
  return (
    <div style={{ margin: '20px' }}>
      <h2>Syncing for the Unread Conversation Messages Count...</h2>
    </div>
  );
}
export default Dealer;
